"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getInlineChildrenAlignment = exports.getInnerRadioCircleDimensions = exports.getClosestOddValue = exports.getClosestEvenValue = exports.getToggleSizeSemantic = void 0;

var _constants = require("./constants");

var _designLanguage = require("@doordash/design-language");

var getToggleSizeSemantic = function getToggleSizeSemantic(_ref) {
  var size = _ref.size,
      type = _ref.type;
  var toggleSize = size === _constants.Sizes.Small ? 'Small' : 'Large';

  switch (type) {
    case _constants.Types.Checkbox:
      return "ControlCheckbox".concat(toggleSize);

    case _constants.Types.Radio:
      return "ControlRadio".concat(toggleSize);

    case _constants.Types.Toggle:
      return "ControlSwitch".concat(toggleSize);

    default:
      return undefined;
  }
};

exports.getToggleSizeSemantic = getToggleSizeSemantic;

var getClosestEvenValue = function getClosestEvenValue(val) {
  if (val % 2 > 0) {
    return 2 * Math.floor(val / 2);
  }

  return val;
};

exports.getClosestEvenValue = getClosestEvenValue;

var getClosestOddValue = function getClosestOddValue(val) {
  if (val % 2 === 0) {
    return 2 * Math.floor(val / 2) + 1;
  }

  return val;
}; // `getClosestEvenValue` and `getClosestOddValue` are utilized for generating
// the inner, "checked" circle that's displayed in `Radio` type Toggles.
// This is necessary due to an issue with Chrome not displaying
// properly centered content when the dimensions of the container are
// an odd number and the dimensions of the inner container are an even number
// (or vice versa)
// This solution keeps the theme definition for the Radio container applied
// as expected, while ensuring that the inner "checked" circle is properly
// displayed in the center across browsers.


exports.getClosestOddValue = getClosestOddValue;

var getInnerRadioCircleDimensions = function getInnerRadioCircleDimensions(outerCircleSize) {
  if (outerCircleSize % 2 === 0) {
    return getClosestEvenValue(Math.round(outerCircleSize / 2));
  }

  return getClosestOddValue(Math.round(outerCircleSize / 2));
};

exports.getInnerRadioCircleDimensions = getInnerRadioCircleDimensions;

var getInlineChildrenAlignment = function getInlineChildrenAlignment(alignment) {
  switch (alignment) {
    case _constants.Alignment.Start:
      return _designLanguage.InlineChildren.Alignment.FlexStart;

    case _constants.Alignment.Baseline:
      return _designLanguage.InlineChildren.Alignment.Baseline;

    case _constants.Alignment.Center:
      return _designLanguage.InlineChildren.Alignment.Center;

    case _constants.Alignment.End:
      return _designLanguage.InlineChildren.Alignment.FlexEnd;

    default:
      return _designLanguage.InlineChildren.Alignment.FlexStart;
  }
};

exports.getInlineChildrenAlignment = getInlineChildrenAlignment;